<template>
  <LayoutTransparentNavbar />
  <slot />
  <LayoutFooter />
</template>

